/// <reference path='../../../typings/hibachiTypescript.d.ts' />
/// <reference path='../../../typings/tsd.d.ts' />
declare var CKEDITOR;

class SWWysiwygController {
    

    //@ngInject
    constructor(
    ){

	}

    public $onInit=()=>{
       
	}
}

class SWWysiwyg implements ng.IDirective{

    public static $inject = ['coreFormPartialsPath', 'hibachiPathBuilder'];
    public templateUrl:string;
    public restrict = 'AE';
    public require = 'ngModel';
    public scope = {};

    public bindToController = {

    };
    public controller=SWWysiwygController;
    public controllerAs="swWysiwyg";


	//@ngInject
    constructor(
    	public $rootScope,
    	public appConfig
    ){
        
    }

    public static Factory(){

        var directive = (
			$rootScope,
			appConfig
        )=>new SWWysiwyg(
			$rootScope,
			appConfig
        );
        directive.$inject = ['$rootScope','appConfig'];

        return directive;
    }


    public link:ng.IDirectiveLinkFn = ($scope:any, element: ng.IAugmentedJQuery, attr:any, ngModel: any) =>{
    			
    			var editorOptions:any;
    			    			
    			var customConfigLocation = '../../../../../../../custom/client/assets/js/ckeditor_config.js';

    			if(typeof CKEDITOR === 'undefined'){
    				throw('swwysiwyg depends on ckeditor js included')
    				return; 
    			}
    			
                if (attr.ckeditor === 'minimal') {
                    // minimal editor
                    editorOptions = {
                    	customConfig: customConfigLocation,
                        height: 100,
                        toolbar: [
                            { name: 'basic', items: ['Bold', 'Italic', 'Underline'] },
                            { name: 'links', items: ['Link', 'Unlink'] },
                            { name: 'tools', items: ['Maximize'] },
                            { name: 'document', items: ['Source'] },
                        ],
                        removePlugins: 'elementspath',
                        resize_enabled: false
                    };
                } else {
                	
                	var paramString = "";
				
					if(attr.applicationkey){
						paramString += "applicationkey="+attr.applicationkey;
					}
					
					if(attr.siteCode && attr.appCode){
						if(paramString.length){
							paramString += '&';
						}
						paramString += 'siteCode='+attr.siteCode+'&appCode='+attr.appCode;
					}
                	
                    // regular editor
                    editorOptions = {
                        allowedContent: true,
                    	customConfig: customConfigLocation,
                        filebrowserBrowseUrl      : this.appConfig['baseURL'] + '/org/Hibachi/ckfinder/ckfinder.html?' + paramString,
						filebrowserImageBrowseUrl : this.appConfig['baseURL'] + '/org/Hibachi/ckfinder/ckfinder.html?Type=Images&' + paramString,
						filebrowserUploadUrl      : this.appConfig['baseURL'] + '/org/Hibachi/ckfinder/core/connector/cfm/connector.cfm?command=QuickUpload&type=Files&' + paramString,
						filebrowserImageUploadUrl : this.appConfig['baseURL'] + '/org/Hibachi/ckfinder/core/connector/cfm/connector.cfm?command=QuickUpload&type=Images&' + paramString,
                        removeButtons: 'About,Form,Checkbox,Radio,TextField,Textarea,Select,Button,Image,ImageButton,HiddenField,Save,CreateDiv,Language,BidiLtr,BidiRtl,Flash,Iframe,addFile,Styles',
                        extraPlugins: ''
                    };
                }

                var editorElement = element[0];

    			var editor = CKEDITOR.replace(editorElement, editorOptions)

                // update ngModel on change
                editor.on('change', function () {
                    ngModel.$setViewValue(this.getData());
                });
    };
}
export{
    SWWysiwyg,
    SWWysiwygController
}